import Vue from 'vue';
import Router from 'vue-router';
import Intro from './views/Intro.vue';
import Welcome from './views/Welcome.vue';
import DayVideo from './views/DayVideo.vue';
import NurseMenu from './views/NurseMenu.vue';
import HotspotMenu from './views/HotspotMenu.vue';
import ComputerMenu from './views/ComputerMenu.vue';
import PatientMenu from './views/PatientMenu.vue';
import Evaluatie from './views/Evaluatie.vue';
import DayEnd from './views/DayEnd.vue';
import EndPage from './views/EndPage.vue';
import DayGame from './views/DayGame.vue';

Vue.use(Router);

const ROUTER_INSTANCE  = new Router({
  routes: [
      {
        path: '/',
        redirect: '/intro',
      },
      {
          path: '/intro',
          name: 'intro',
          component: Intro
      },
      {
          path: '/welcome',
          name: 'welcome',
          component: Welcome,
      },
      {
          path: '/morning/:day',
          name: 'morning',
          component: DayVideo,
      },
      {
          path: '/day/:day',
          name: 'day',
          component: DayGame,
          redirect: 'day/:day/nurse',
          children: [
              {
                  path: 'nurse',
                  name: 'nurse',
                  component: NurseMenu,
              },
              {
                  path: 'hotspot',
                  name: 'hotspot',
                  component: HotspotMenu,
              },
              {
                  path: 'computer',
                  name: 'computer',
                  component: ComputerMenu,
              },
              {
                  path: 'patient',
                  name: 'patient',
                  component: PatientMenu,
              },
              {
                  path: 'feedback',
                  name: 'feedback',
                  component: Evaluatie,
              },
          ]
      },
      {
          path: '/night/:day',
          name: 'night',
          component: DayEnd,
      },
      {
          path: '/end',
          name: 'end',
          component: EndPage,
      },
  ],
});

interface StringMap {
    [name: string]: string;
}
const PAGE_TITLE:StringMap = {
    "intro": "Intro",
    "welcome": "Welcome",
    "morning": "Morning",
    "nurse": "Nurse",
    "computer": "Computer",
    "hotspot": "Interact",
    "patient": "Talk",
    "feedback": "Feedback",
    "night": "Night",
    "end": "End"
};

ROUTER_INSTANCE.afterEach((toRoute:any, fromRoute:any) => {
    let title = PAGE_TITLE[toRoute.name];
    if( undefined != title ) {
        window.document.title = 'Delirium - ' + title;
    } else {
        window.document.title = 'Delirium - ' + toRoute.name;
    }
});

export default ROUTER_INSTANCE;
